import type {
    PurchaseInvoice,
    PurchaseInvoiceForm,
    PurchaseInvoiceQueryParams,
    PurchaseInvoiceVo
} from "../../../../common/types/purchaseInvoice";
import httpRequest from "./index";
import { BaseService } from "@/api/baseService";

class PurchaseInvoiceService extends BaseService<
    PurchaseInvoice[],
    PurchaseInvoiceVo,
    PurchaseInvoiceQueryParams,
    PurchaseInvoiceForm
> {
    public async getListByProjectId(
        projectId: number,
        type: number,
        params: PurchaseInvoiceQueryParams
    ): Promise<PurchaseInvoice[]> {
        const { data } = await this.service.get(`${this.path}/paging/project-id/${projectId}/type/${type}`, { params });
        return data;
    }

    public async create(form: PurchaseInvoiceForm): Promise<PurchaseInvoice[]> {
        const { data } = await this.service.post(`${this.path}`, form);
        return data;
    }
}

export const purchaseInvoiceService = new PurchaseInvoiceService("/purchase-invoice", httpRequest);
